module.exports = __webpack_public_path__ + "static/media/NewsScraper.d83b2598.png";